import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Asamblea} from '../../model/asamblea';
import {MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {UntypedFormControl, Validators} from '@angular/forms';
import {Representante} from '../../model/representante';
import {functionUtil, functionHelper} from 'src/app/util/functionConst';
import {IntranetService} from '../../intranet.service';
import {RegistroRepresentanteComponent} from './registro-representante/registro-representante-dialog.component';
import {AlertaService} from 'src/app/util/alerta.service';
import {Parametro} from '../../model/parametro';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {ConfirmDialogComponent} from 'src/app/util/confirm-dialog/confirm-dialog.component';
import {ConfirmDialog} from 'src/app/util/confirm-dialog/confirmDialog';
import {Router} from '@angular/router';

@Component({
  selector: 'sura-representante',
  templateUrl: './representante.component.html',
  styleUrls: ['./representante.component.scss']
})
export class RepresentanteComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  linkActive = '';
  listTipoDocumento: Parametro[] = [];
  newArrayRepresentante: Representante[] = [];
  newAsamblea: Asamblea = new Asamblea();
  displayedColumns: string[] = ['NUMERODOCUMENTO', 'TITULAR', 'REPRESENTANTE', 'OPCIONES'];
  dataSource = new MatTableDataSource<Representante>(this.newArrayRepresentante);
  disableBtnAgregar = true;
  disableBtnEliminar = true;
  nroAsambleaValidacion = new UntypedFormControl('', [Validators.required]);

  constructor(
    private _intranetService: IntranetService,
    private alertaService: AlertaService,
    public dialogRegistro: MatDialog,
    private router: Router) {
    this.linkActive = this.router.url;
  }

  fnKeyDownNumeric = functionUtil.fnKeyDownNumeric;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  fnNumericMobile = functionUtil.fnNumericMobile;

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this._intranetService.obtenerParametro(ParametrosConst.TIPO_DOCUMENTO).then(resultado => {
      if (resultado instanceof Array) {
        this.listTipoDocumento = resultado;
      }
    }).catch(error => {
      this.alertaService.error(error);
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getErrorMessageNroAsamblea() {
    return this.nroAsambleaValidacion.hasError('required') ? 'Campo Obligatorio' : '';
  }

  limpiarComponentes() {
    this.limpiarGrillaRepresentantes();
    this.newAsamblea.organizador.descripcion = '';
  }

  limpiarGrillaRepresentantes() {
    this.newArrayRepresentante.splice(0, this.newArrayRepresentante.length);
    this.dataSource._updateChangeSubscription();
  }

  changeAsamblea() {
    this.disableBtnAgregar = true;
    this.newAsamblea.organizador.id = null;
    this.newAsamblea.organizador.descripcion = '';
  }

  buscarAsamblea() {
    this.limpiarComponentes();
    this._intranetService.obtenerOrganizador(this.newAsamblea.id).then(resp => {
      this.newAsamblea.organizador.id = resp[0].idOrganizador;
      this.newAsamblea.organizador.descripcion = resp[0].organizador;
      if (resp[0].estadoAsamblea === '1') {
        this.disableBtnAgregar = false;
        this.disableBtnEliminar = false;
        this.listarRepresentantes();
      } else {
        this.disableBtnAgregar = false;
        this.disableBtnEliminar = true;
        if (resp[0].messageWarn != null || resp[0].messageWarn !== '') {
          this.alertaService.warning(resp[0].messageWarn);
          setTimeout(() => {
            this.listarRepresentantes();
          }, ParametrosConst.TIEMPO_DURACION_ALERTA_ANIDADO);
        } else {
          this.listarRepresentantes();
        }
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  listarRepresentantes() {
    this._intranetService.listarRepresentantes(this.newAsamblea.id).then(list => {
      if (list instanceof Array) {
        this.llenarGrillaRepresentantes(list);
      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  llenarGrillaRepresentantes(arrayResult) {
    this.newArrayRepresentante.splice(0, this.newArrayRepresentante.length);
    for (let index = 0; index < arrayResult.length; index++) {
      const r = new Representante();
      r.id = arrayResult[index].idRepresentante;
      r.idFoto = arrayResult[index].idFoto;
      r.idPersona = arrayResult[index].idPersona;
      r.idAsamblea = arrayResult[index].idAsamblea;
      r.tipoDocumento = functionHelper.getDescripcionParametro(arrayResult[index].tipoDocumento, this.listTipoDocumento);

      r.numeroDocumento = arrayResult[index].numeroDocumento;
      r.nombres = arrayResult[index].nombres;
      r.apellidos = arrayResult[index].apellidos;
      r.correo = arrayResult[index].correo;
      r.descripcion = functionHelper.getDescripcionParametro(
        arrayResult[index].tipoDocumentoR,
        this.listTipoDocumento) + ' ' + arrayResult[index].numeroDocumentoR + ' ' + arrayResult[index].nombresR;
      this.newArrayRepresentante.push(r);
    }
    this.dataSource._updateChangeSubscription();
  }

  showEliminarRepresentante(representante: Representante) {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = ParametrosConst.MSJ_ELIMINAR;
    confirmDialog.labelOk = 'Eliminar';
    const dialogRef = this.dialogRegistro.open(ConfirmDialogComponent, {
      width: '270px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
        this.eliminarRepresentante(representante);
      }
    });
  }

  eliminarRepresentante(representante: Representante) {
    this._intranetService.eliminarRepresentante(representante.idFoto).then(respuesta => {
      this.alertaService.success(respuesta);
      this.listarRepresentantes();
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  openRegistroAsistente() {
    const dialogRegistroAsistente = this.dialogRegistro.open(RegistroRepresentanteComponent, {
      width: '650px',
      data: this.newAsamblea,
      disableClose: true
    });
    dialogRegistroAsistente.afterClosed().subscribe(respuesta => {
      if (respuesta) {
        this.listarRepresentantes();
      }
    });
  }
}
